<cac-dialog-layout
  [title]="data.blogCategory ? 'Edit Blog Category' : 'Create New Blog Category'"
  subtitle="Enter the required data and save"
  (onSubmit)="onSubmit($event)"
>
  <cac-form-builder [options]="form" class="mt-5"></cac-form-builder>
</cac-dialog-layout>
